import type { Message, StreamFrame } from './types';

const GENERIC_ERROR = 'Something went wrong - please try again.';

const replaceLast = (messages: Message[], message: Message): Message[] => [...messages.slice(0, -1), message];

// Applies a stream frame to the message list, mutating the trailing assistant placeholder
// that `sendMessage` appended on submit. Pure so it can be unit-tested and used inside a
// functional `setMessages` update.
//
// `done.content` is authoritative: halting tools (Navigate/Support) end the turn without
// streaming any deltas, so their reply exists only on the terminal frame. Tool calls on
// `done` are handled by the caller (runToolCalls), not here.
export function applyStreamFrame(messages: Message[], frame: StreamFrame): Message[] {
  const last = messages[messages.length - 1];
  if (!last) return messages;

  switch (frame.type) {
  case 'status':
    return replaceLast(messages, { ...last, status: frame.label });
  case 'delta':
    return replaceLast(messages, { ...last, content: last.content + frame.text, status: undefined });
  case 'done':
    return replaceLast(messages, {
      ...last,
      content: frame.content,
      metrics: frame.metrics,
      isStreaming: false,
      status: undefined,
    });
  case 'error':
    return replaceLast(messages, {
      ...last,
      content: last.content || GENERIC_ERROR,
      isStreaming: false,
      status: undefined,
      error: true,
    });
  default:
    return messages;
  }
}
